export default __webpack_public_path__ + "static/media/student_template.42d61771.png";